module.exports = __webpack_public_path__ + "media/dump-truck-load-raise.ec1123ac.mp3";